
export default {
  name: 'Features',
  components: {
    Icon: () => import('~/common/shared-components/Icon.vue'),
  },
};
